module.exports = __webpack_public_path__ + "img/Ks.fa4ba0b3.png";